import CnpjUtils from "../../shared/utils/CnpjUtils";

async function getConectaPedidos(filtros = {}) {
  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    access_token: sessionStorage.getItem("token"),
    client_id: localStorage.getItem("clientid"),
  };
  if (filtros.laboratorio) headers.laboratorio = filtros.laboratorio;

  const params = {
    cliente: filtros.cnpjOtica ? CnpjUtils.cleanCnpj(filtros.cnpjOtica) : "",
    idPedidoOpticlick: filtros.pedidoEssilor || "",
    idPedidoOtica: filtros.pedidoOtica || "",
    dataInicio: filtros.dataInicio || "",
    dataFim: filtros.dataFim || "",
    cupomPromocional: filtros.cupom || "",
    nomeCampanha: filtros.campanha || "",
    idParCupom: filtros.parCupom || "",
    laboratorio: filtros.laboratorio ? CnpjUtils.cleanCnpj(filtros.laboratorio) : "",
    pagina: filtros.pagina || "",
    limite: filtros.limite || "",
  };

  Object.keys(params).forEach(key => {
    if (params[key] === "" || params[key] === null || params[key] === undefined) {
      delete params[key];
    }
  });

  const queryString = Object.entries(params)
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join("&");

  try {
    const response = await fetch(
      `${process.env.REACT_APP_ESSILOR_API}gestao-pedidos-laboratorio/v1/conecta-pedidos?${queryString}`,
      { method: "GET", headers }
    );

    const json = await response.json().catch(() => ({}));

    if (response.status >= 400) {
      const mensagem = Array.isArray(json) ? json[0]?.mensagem : json?.mensagem;
      return { status: response.status, pedidos: [], paginaAtual: 1, paginaTotal: 1, quantidadeTotal: 0, erro: mensagem || "" };
    }

    return {
      status: response.status,
      pedidos: Array.isArray(json?.pedidos) ? json.pedidos : [],
      paginaAtual: json?.paginaAtual ?? filtros.pagina ?? 1,
      paginaTotal: json?.paginaTotal ?? 1,
      quantidadeTotal: json?.quantidadePedidosTotal ?? 0,
      erro: "",
    };
  } catch (error) {
    return { status: 0, pedidos: [], paginaAtual: 1, paginaTotal: 1, quantidadeTotal: 0, erro: "Falha de comunicação com o servidor." };
  }
}

export { getConectaPedidos };
